/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import { NetworkScreen, PRIMARY_NETWORKS } from '@/shadcn/components/AddSocialModal/connect-social.tsx';
import { assetBase } from '@/lib/asset-base.ts';
import { networkFromServiceCode } from '@/lib/network-service-codes.ts';
import * as _ from 'underscore';

class TypeSelection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sortedTypes: [],
			moreOpen: false,
			showTwitterWarning: false,
			//showTikTokWarning: false,
			//showYouTubeWarning: false,
			//showSnapchatWarning: false
			showRedditWarning: false
		};

		this.sortTypes = this.sortTypes.bind(this);
		this.generateButton = this.generateButton.bind(this);

	}

	componentDidMount() {

		if (this.props.socials.types.length) {
			this.sortTypes(this.props.socials.types);
		}

		if (dataLayer && this.props.onboarding) {
			dataLayer.push({
				'event': 'onboarding-new-social'
			});
		}

	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.socials.types.length && !this.state.sortedTypes.length) {
			this.sortTypes(this.props.socials.types);
		}

	}

	sortTypes(types) {
		var constants = this.props.app.config.constants,
				sortOrder = [
					constants.POST_SVC_FACEBOOK,
					constants.POST_SVC_TWITTER,
					constants.POST_SVC_BLUESKY,
					constants.POST_SVC_PINTEREST,
					constants.POST_SVC_INSTAGRAM_BUSINESS,
					constants.POST_SVC_YOUTUBE,
					constants.POST_SVC_LINKEDIN,
					constants.POST_SVC_THREADS,
					constants.POST_SVC_TIKTOK,
					constants.POST_SVC_GMYBUSINESS,
					constants.POST_SVC_SNAPCHAT,
					constants.POST_SVC_REDDIT,
					constants.POST_SVC_WORDPRESS,
					constants.POST_SVC_BLOGGER,
					constants.POST_SVC_TUMBLR,
					constants.POST_SVC_MASTODON,
					constants.POST_SVC_FEED,
					constants.POST_SVC_DISCORD,
					constants.POST_SVC_STOCKTWITS,
					constants.POST_SVC_NEXTDOOR,
					constants.POST_SVC_SLACK,
				],
				sorted = [];

		if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
			sortOrder = [
				constants.POST_SVC_FACEBOOK,
				constants.POST_SVC_BLUESKY,
				constants.POST_SVC_PINTEREST,
				constants.POST_SVC_INSTAGRAM_BUSINESS,
				constants.POST_SVC_YOUTUBE,
				constants.POST_SVC_LINKEDIN,
				constants.POST_SVC_THREADS,
				constants.POST_SVC_TIKTOK,
				constants.POST_SVC_GMYBUSINESS,
				constants.POST_SVC_SNAPCHAT,
				constants.POST_SVC_REDDIT,
				constants.POST_SVC_WORDPRESS,
				constants.POST_SVC_BLOGGER,
				constants.POST_SVC_TUMBLR,
				constants.POST_SVC_MASTODON,
				constants.POST_SVC_FEED,
				constants.POST_SVC_DISCORD,
				constants.POST_SVC_STOCKTWITS,
				constants.POST_SVC_NEXTDOOR,
				constants.POST_SVC_TWITTER,
				constants.POST_SVC_SLACK,
			];
		}

		if (this.state.sortedTypes.length === 0) {
			if (types.length) {
				for (let i = 0; i < sortOrder.length; ++i) {
					for (let j = 0; j < types.length; ++j) {
						if (sortOrder[i] == types[j].id && this.props.hideTypes.indexOf(sortOrder[i]) === -1) {
							sorted.push(types[j]);
						}
					}
				}
			}

			this.setState({
				sortedTypes: sorted
			});
		}

	}

	/*
	 * Whether picking this service starts the connect immediately, rather than
	 * first showing the accounts already connected to it. True in the contexts
	 * that have no account list to show, and true for a service the user has
	 * none of yet — there would be nothing on that screen.
	 */
	isDirectConnect(type) {
		let directConnect = (['config', 'posting', 'posting-tool', 'new-route'].indexOf(this.props.context) !== -1);

		if (_.findWhere(this.props.socials.counts, {type: type.id}) === undefined) {
			directConnect = true;
		}

		return directConnect;

	}

	/*
	 * What clicking a service does. Extracted from the render branches so the
	 * legacy icon list and the tile grid can't drift on it — the policy is the
	 * part that matters, and it isn't obvious: two services collect credentials
	 * from us instead of round-tripping through OAuth, and both of those gate on
	 * the plan first, because the connect they'd start would be refused.
	 */
	connectHandlerFor(type) {
		let constants = this.props.app.config.constants,
			credentialViews = {},
			directConnect = this.isDirectConnect(type);

		credentialViews[constants.POST_SVC_MASTODON] = 'providehandle';
		credentialViews[constants.POST_SVC_BLUESKY]  = 'blueskycreds';

		if (directConnect && credentialViews[type.id] !== undefined) {
			return () => {
				if (this.props.user.perms.resources.outputsAvailable == 0) {
					this.props.showUpgradeModal(this.props.closeAllModals, 'socials', null, 'social_modal');
					return;
				}
				this.props.switchView(credentialViews[type.id]);
			};
		}

		return ConnectMixin.connectService.bind(this);

	}

	/*
	 * The service's display name. The server sends internal names for four of
	 * them ("GMyBusiness", "InstagramBusiness", …) which no user should read.
	 */
	labelFor(type) {
		let label = String(type.name || '');

		if (label.match('GMy')) {
			return 'Google Business Profile';
		}
		if (label.match('InstagramBusiness')) {
			return 'Instagram Business or Creator';
		}
		if (label.match('Twitter')) {
			return 'X (Twitter)';
		}
		if (label.match(/youtube/i)) {
			return 'YouTube';
		}

		return label;

	}

	generateButton(type, i) {
		let index = ConstantMixin.getIconIndexByCode(type.id),
			Icon = IconFactory[index],
			directConnect = this.isDirectConnect(type),
			constants = this.props.app.config.constants;

		// Ignore the Test service
		if (parseInt(type.id) === 0) {
			return;
		}

		// Ignore output feed if the user is a client
		if (parseInt(type.id) === constants.POST_SVC_FEED && this.props.user.detail.isClient) {
			return;
		}

		if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
			if (type.id == constants.POST_SVC_TWITTER) {
				return (
						<li className="social-connector"
								key={i}
								data-serviceid={type.id}
								data-direct={directConnect}
								onMouseOver={() => {
									this.setState({
										showTwitterWarning: true
									});
								}}
								onMouseOut={() => {
									this.setState({
										showTwitterWarning: false
									});
								}}>
							<Icon large={true} inactive={true} round={true}/>
							{(this.state.showTwitterWarning) ? (
									<div className="twitter-warning">
										X (Twitter) is currently unavailable
									</div>
							) : null}
						</li>
				);
			}

			if (this.props.twitterCount >= 1 && type.id == constants.POST_SVC_TWITTER) {
				return (
					<li className="social-connector" key={i} data-serviceid={type.id}
							data-direct={directConnect} title={"This output is not available"}>
						<Icon large={true} inactive={true} round={true}/>
					</li>
				);
			}
		}

		if (type.id === constants.POST_SVC_FACEBOOK) {
			return (
				<li className="social-connector"
					key={i}
					data-serviceid={type.id}
					data-subtype={constants.FB_SUBTYPE_PAGE}
					data-direct={directConnect}
					onClick={ConnectMixin.connectService.bind(this)}
					role="button"
					aria-label={type.name}
					title={type.name}>
					<Icon large={true} round={true}/>
				</li>
			);
		}

		if ((type.id === constants.POST_SVC_MASTODON || type.id === constants.POST_SVC_BLUESKY) && directConnect) {
			return (
				<li className="social-connector" key={i} data-serviceid={type.id} data-direct={false}
					onClick={this.connectHandlerFor(type)}
					role="button" aria-label={type.name} title={type.name}>
					<Icon large={true} round={true}/>
				</li>
			);
		}

		// if (type.id === constants.POST_SVC_TIKTOK && ['input', 'list-add', 'list'].indexOf(this.props.context) !== -1) {
		// 	return (
		// 			<li className="social-connector"
		// 					key={i}
		// 					data-serviceid={type.id}
		// 					data-direct={directConnect}
		// 					onMouseOver={() => {
		// 						this.setState({
		// 							showTikTokWarning: true
		// 						});
		// 					}}
		// 					onMouseOut={() => {
		// 						this.setState({
		// 							showTikTokWarning: false
		// 						});
		// 					}}>
		// 				<Icon large={true} inactive={true} round={true}/>
		// 				{(this.state.showTikTokWarning) ? (
		// 						<div className="twitter-warning">
		// 							Tiktok is not available for feeds
		// 						</div>
		// 				) : null}
		// 			</li>
		// 	);
		// }

		// if (type.id === constants.POST_SVC_YOUTUBE && ['input', 'list-add', 'list'].indexOf(this.props.context) !== -1) {
		// 	return (
		// 			<li className="social-connector"
		// 					key={i}
		// 					data-serviceid={type.id}
		// 					data-direct={directConnect}
		// 					onMouseOver={() => {
		// 						this.setState({
		// 							showYouTubeWarning: true
		// 						});
		// 					}}
		// 					onMouseOut={() => {
		// 						this.setState({
		// 							showYouTubeWarning: false
		// 						});
		// 					}}>
		// 				<Icon large={true} inactive={true} round={true}/>
		// 				{(this.state.showYouTubeWarning) ? (
		// 						<div className="twitter-warning">
		// 							YouTube is not available for feeds
		// 						</div>
		// 				) : null}
		// 			</li>
		// 	);
		// }

		// if (type.id === constants.POST_SVC_SNAPCHAT && ['input', 'list-add', 'list'].indexOf(this.props.context) !== -1) {
		// 	return (
		// 			<li className="social-connector"
		// 					key={i}
		// 					data-serviceid={type.id}
		// 					data-direct={directConnect}
		// 					onMouseOver={() => {
		// 						this.setState({
		// 							showSnapchatWarning: true
		// 						});
		// 					}}
		// 					onMouseOut={() => {
		// 						this.setState({
		// 							showSnapchatWarning: false
		// 						});
		// 					}}>
		// 				<Icon large={true} inactive={true} round={true}/>
		// 				{(this.state.showSnapchatWarning) ? (
		// 						<div className="twitter-warning">
		// 							Snapchat is not available for feeds
		// 						</div>
		// 				) : null}
		// 			</li>
		// 	);
		// }

		if (type.id === constants.POST_SVC_REDDIT) {
			return null;
			// return (
			// 		<li className="social-connector"
			// 				key={i}
			// 				data-serviceid={type.id}
			// 				data-direct={directConnect}
			// 				onMouseOver={() => {
			// 					this.setState({
			// 						showRedditWarning: true
			// 					});
			// 				}}
			// 				onMouseOut={() => {
			// 					this.setState({
			// 						showRedditWarning: false
			// 					});
			// 				}}>
			// 			<Icon large={true} inactive={true} round={true}/>
			// 			{(this.state.showRedditWarning) ? (
			// 					<div className="twitter-warning">
			// 						Reddit currently unavailable
			// 					</div>
			// 			) : null}
			// 		</li>
			// );
		}

		// TODO: set up permissions and actions for clicking on a service not in your subscription
		//
		let tipLabel = this.labelFor(type);

		return (
			<li className="social-connector" key={i} data-serviceid={type.id}
					data-direct={directConnect} onClick={ConnectMixin.connectService.bind(this)}
					role="button" aria-label={tipLabel} title={tipLabel}>
				<Icon large={true} round={true}/>
			</li>
		);
	}

	/*
	 * The sorted service list as the redesigned picker's marks
	 * (shadcn/AddSocialModal/connect-social), opted into with `tile`. Nothing but
	 * the artwork changes: the ordering, the client-hidden output feed, the
	 * disabled X while twitter is down, the Reddit omission, the credential
	 * routes and the entitlement gate are all still decided here.
	 *
	 * The row order is the design's (`PRIMARY_NETWORKS`), which is a deliberate
	 * choice about what to promote, not an accident of the frame. Everything else
	 * follows the server's sort, which is where the rest of that ordering lives.
	 */
	tileNetworks() {
		let constants = this.props.app.config.constants,
			twitterDisabled = (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled),
			items = [];

		for (let i = 0; i < this.state.sortedTypes.length; ++i) {
			let type = this.state.sortedTypes[i],
				id = parseInt(type.id, 10),
				network = networkFromServiceCode(type.id),
				item = null;

			// The same three omissions the legacy list makes: the Test service,
			// the output feed for a client, and Reddit.
			if (id === 0 || id === constants.POST_SVC_REDDIT) {
				continue;
			}
			if (id === constants.POST_SVC_FEED && this.props.user.detail.isClient) {
				continue;
			}
			// No mark in the registry means nothing to draw a tile with.
			if (network === null) {
				continue;
			}

			item = {
				id: id,
				network: network,
				label: this.labelFor(type),
				data: {
					serviceid: id,
					direct: this.isDirectConnect(type)
				}
			};

			// Facebook connects as a Page; the other two subtypes are reached
			// from the chooser afterwards.
			if (id === constants.POST_SVC_FACEBOOK) {
				item.data.subtype = constants.FB_SUBTYPE_PAGE;
			}

			if (twitterDisabled && id === constants.POST_SVC_TWITTER) {
				item.disabled = true;
				item.disabledReason = 'X (Twitter) is currently unavailable';
			}

			items.push(item);
		}

		return items;

	}

	/*
	 * The two rows: the design's six, then everything else in the server's order.
	 *
	 * A network only reaches the top row if it is CONNECTABLE — which is how a
	 * disabled X leaves it while twitter is off, rather than sitting dead in the
	 * hero row. The row is then filled back to six from the remainder, because
	 * the frame draws six and a gap in a 6-column grid reads as a missing tile
	 * rather than as an absence. This mirrors what prod's own sort order did with
	 * twitter: demote it, promote the next.
	 */
	tileRows() {
		let items = this.tileNetworks(),
			primary = [],
			more = [];

		for (let i = 0; i < PRIMARY_NETWORKS.length; ++i) {
			let promoted = items.find((item) => {
				return item.network === PRIMARY_NETWORKS[i] && !item.disabled;
			});

			if (promoted !== undefined) {
				primary.push(promoted);
			}
		}

		more = items.filter((item) => { return primary.indexOf(item) === -1; });

		while (primary.length < PRIMARY_NETWORKS.length && more.length) {
			let next = more.findIndex((item) => { return !item.disabled; });

			if (next === -1) {
				break;
			}

			primary.push(more[next]);
			more.splice(next, 1);
		}

		return {primary: primary, more: more};

	}

	renderTileGrid() {
		let rows = this.tileRows();

		return (
			<NetworkScreen
				base={assetBase(this.props.app.config)}
				primary={rows.primary}
				more={rows.more}
				moreOpen={this.state.moreOpen}
				moreLabel="More destinations"
				heading={this.props.tileHeading}
				description={this.props.tileDescription}
				onToggleMore={() => { this.setState({moreOpen: !this.state.moreOpen}); }}
				onSelectNetwork={(network, event) => {
					let type = _.find(this.state.sortedTypes, (entry) => {
						return parseInt(entry.id, 10) === parseInt(event.currentTarget.dataset.serviceid, 10);
					});

					if (type !== undefined) {
						this.connectHandlerFor(type).call(this, event);
					}
				}} />
		);

	}

	render() {
		if (this.props.tile) {
			return this.renderTileGrid();
		}

		let containerClass = 'social-connector-wrapper clearfix',
			onboardingMain = this.state.sortedTypes.slice(0, 10),
			onboardingOptional = this.state.sortedTypes.slice(10);

		if (this.props.extraClasses !== '') {
			containerClass += ' ' + this.props.extraClasses;
		}

		return (
			<div className={containerClass}>
				<ul className="social-connector-list">
					{this.state.sortedTypes.map(function (type, i) {
						return this.generateButton(type, i);
					}, this)}
				</ul>
			</div>
		);
	}
}

TypeSelection.displayName = "TypeSelection";

TypeSelection.propTypes = {
	types: PropTypes.array,
	switchView: PropTypes.func,
	userPerms: PropTypes.object,
	setModal: PropTypes.func,
	recordPath: PropTypes.func,
	router: PropTypes.object,
	redirect: PropTypes.string,
	extraClasses: PropTypes.string,
	trialEligible: PropTypes.bool,
	tile: PropTypes.bool,
	tileHeading: PropTypes.string,
	tileDescription: PropTypes.string
};

TypeSelection.defaultProps = {
	types: [],
	switchView: null,
	userPerms: {},
	setModal: null,
	recordPath: null,
	router: null,
	redirect: '',
	onboarding: null,
	extraClasses: '',
	hideTypes: [],
	trialEligible: false,
	tile: false
};

export default SubscriptionModule(TypeSelection);
